import React, { useEffect } from "react";
import { MainSpinner } from "../../../components";
import { DrugInteractionsDetails } from "../../../components/DrugInteractions/Details";
import { useDispatch, useStore } from "../../../store";

import {
  fetchDrugInteractionDetails,
  clearDrugInteractionsDetails,
} from "../../../store/drug-interactions/actions";

const DrugInteractionsDetailsLayout = () => {
  const dispatch = useDispatch();
  const { drugInteractions } = useStore();

  const { isFetching, drugDetail } = drugInteractions;
  const { metaData } = drugDetail;
  const { apiPath } = metaData;

  useEffect(() => {
    fetchDrugInteractionDetails(dispatch, apiPath);
    return () => clearDrugInteractionsDetails(dispatch);
  }, [dispatch, apiPath]);

  if (isFetching) {
    return <MainSpinner />;
  }

  return <DrugInteractionsDetails />;
};

export default DrugInteractionsDetailsLayout;
